import React, { FunctionComponent } from 'react';
import { faMoneyCheckAlt } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconBankData: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faMoneyCheckAlt} />;

export { BrassIconBankData };
